import { render, staticRenderFns } from "./BusinessApplication.vue?vue&type=template&id=34553318&scoped=true&"
import script from "./BusinessApplication.vue?vue&type=script&lang=js&"
export * from "./BusinessApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34553318",
  null
  
)

export default component.exports